import React, { useState, useEffect, useCallback, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '@components/common/Layout';
import { showModal } from '@store/actions/commonAction';
import SatDataGrid from '@components/common/satUI/SatDataGrid';
import SatDataGridNew from '@components/common/satUI/SatDataGridNew'; 
import SatPagination from '@components/common/satUI/SatPagination';
import {getCommonCodeDtlList, saveRoleAgents} from '@store/actions/roleAction';
import {getAppAgentRoleMenu, updateSearchParamsInfo, getAgentRoles, saveAppAgentRoleMenu, getAgentsTakenRole, 
        roleAgentExcelDownload, getHqListByChannel, getAgencyListByHq, getHqAgencyClear} from '@store/actions/agentRoleAction';
import SatInput from '@components/common/satUI/SatInput';
import { getToday } from '@common/utils/date';

import AgentListRead from '@components/agentRole/AgentListRead';
import AgentListEdit from '@components/agentRole/AgentListEdit';

const AgentRole = () => {
    
    const dispatch = useDispatch();
    const [checkAll, setCheckAll] = useState(false);
    const {codeList} = useSelector(state => state.roleReducer);
    const {searchParams, menuList, agentList, agentTakenList, agentTotalCount, hqList, agencyList} = useSelector(state => state.agentRoleReducer);    
    const [readYn, setReadYn] = useState(true);
    const [agentVisible, setAgentVisible] = useState(true);
    const [pageNum, setPageNum] = useState({pageIndex: 0});
    const [agentEditVisible, setAgentEditVisible] = useState(false);
    const [initial, setInitial] = useState(false);
    const [gridClass, setGridClass] = useState('check-wrap chk-style disabled');
    const [selectRow, setSelectRow] = useState({
        rowIndex : ''
    });
    const [selectEmpnos, setSelectEmpnos] = useState([])
    const [searchCondition, setSearchCondition] = useState({
        aplctnTpCd: '01',
        aplctnDvcTyCd: '01',
        chnlCd:'',
        orgChnlCd:'',
        agentNm: '',
        compCd:'',
        roleId:'',
        empno:'',        
        hqCd:'',
        agncCd:'',
        rspofcCd:'',
        agentNo:'',
        hqSvcOrgCd:'',
        agncSvcOrgCd:''
    });
    
    useEffect(() => {

        //공통코드 조회
        dispatch(
            getCommonCodeDtlList({
                cdTyId:'ORG_CHNL_CD',
                useYn:'Y'
            })
        );      

        dispatch(
              getAgentsTakenRole({
                 chnlCd:searchCondition.chnlCd
              })
        );

        dispatch(
            getHqListByChannel({              
              'chnlCd': searchCondition.chnlCd
          }),
        );  

    }, []);

    const allMenuCheck = (checked) => {

        if(checked === true) {
            
            const roleAgent = menuList.map(f => Object.assign(f, {isChecked: true, orgChnlCd : searchCondition.orgChnlCd, agentNm : searchCondition.agentNm, 
                compCd : searchCondition.compCd, hqCd : searchCondition.hqCd, agncCd : searchCondition.agncCd, rspofcCd:searchCondition.rspofcCd, 
                empno : searchParams.searchEmpNo, useYn:'Y'}) );

            dispatch({type: 'SET_APP_AGENT_ROLE_MENU_LIST', payload: roleAgent });

            let newSelectEmpnos= [...selectEmpnos];
            
            roleAgent.forEach((f,index)=> {
                if(f.isChecked) newSelectEmpnos = [...new Set([...newSelectEmpnos, roleAgent[index]])]
            })
            
            setSelectEmpnos(newSelectEmpnos);            
            
        }else{           

            const roleAgent = menuList.map(f => Object.assign(f, {isChecked: false, menuEmpno : '', orgChnlCd : searchCondition.orgChnlCd, agentNm : searchCondition.agentNm, 
                compCd : searchCondition.compCd, hqCd : searchCondition.hqCd, agncCd : searchCondition.agncCd, rspofcCd:searchCondition.rspofcCd, 
                empno : searchParams.searchEmpNo, useYn:'N'}) );

            dispatch({type: 'SET_APP_AGENT_ROLE_MENU_LIST', payload: roleAgent });

            let newSelectEmpnos= [...selectEmpnos];
            
            roleAgent.forEach((f,index)=> {
                if(!f.isChecked) newSelectEmpnos = [...new Set([...newSelectEmpnos, roleAgent[index]])]
            })
            
            setSelectEmpnos(newSelectEmpnos);
        }   

        setCheckAll(!checkAll);

    }

    const singleCheck = (checked, menuId) => {        

        const i = menuId.lastIndexOf('_');
      
        if(checked === true) {

            const roleAgent = menuList.map(f=> f.menuId === menuId ? Object.assign(f, 
                {isChecked: checked, orgChnlCd : searchCondition.orgChnlCd, agentNm : searchCondition.agentNm, compCd : searchCondition.compCd, 
                    hqCd : searchCondition.hqCd, agncCd : searchCondition.agncCd, rspofcCd:searchCondition.rspofcCd,  empno : searchParams.searchEmpNo, useYn:'Y'}) : f );

            if(menuId.substring(i+1).substring(3,5) == '00') {  //상위메뉴

                const list = roleAgent.map(f => f.menuId === menuId ? Object.assign(f, {isChecked: checked}) : f );
                dispatch({type: 'SET_APP_AGENT_ROLE_MENU_LIST', payload: list });

            }else if(menuId.substring(i+1).substring(5) == '000') { //상위메뉴 

                const list = roleAgent.map(f => f.menuId === menuId ? Object.assign(f, {isChecked: checked}) : f );
                const secondMenuList = list.map(f => f.menuId === menuId.substring(0,i+1)+menuId.substring(i+1).substring(0,3)+'00000' ?  Object.assign(f, {isChecked: checked}) : f );
                console.log(menuId.substring(0,i+1)+menuId.substring(i+1).substring(0,3)+'00000' );

                dispatch({type: 'SET_APP_AGENT_ROLE_MENU_LIST', payload: secondMenuList });

            }else{  //하위메뉴

                const firstMenuList = roleAgent.map(f => f.menuId === menuId  ?  Object.assign(f, {isChecked: checked}) : f );
                const secondMenuList = firstMenuList.map(f => f.menuId === menuId.substring(0,i+1)+menuId.substring(i+1).substring(0,6)+'00' ?  Object.assign(f, {isChecked: checked}) : f );
                const thirdMenuList = secondMenuList.map(f => f.menuId === menuId.substring(0,i+1)+menuId.substring(i+1).substring(0,3)+'00000' ?  Object.assign(f, {isChecked: checked}) : f );
                dispatch({type: 'SET_APP_AGENT_ROLE_MENU_LIST', payload: thirdMenuList });

            }
            
            const dsPensList6 = roleAgent.find(f=> f.menuId === menuId);            
            setSelectEmpnos([...new Set([...selectEmpnos, dsPensList6])])            

        } else {                       

            if(menuId.substring(i+1).substring(3,5) == '00') { //상위메뉴                            
                const resultList = menuList.map(f => f.menuId.substring(i+1).substring(0,3) === menuId.substring(i+1).substring(0,3) ? Object.assign(f, {isChecked: checked, menuEmpno:''}) : f );
                dispatch({type: 'SET_APP_AGENT_ROLE_MENU_LIST', payload: resultList });                
            }else if(menuId.substring(i+1).substring(5) == '000') { //상위메뉴     
                const resultList = menuList.map(f => f.menuId.substring(i+1).substring(0,6) === menuId.substring(i+1).substring(0,6) ? Object.assign(f, {isChecked: checked, menuEmpno:''}) : f );
                dispatch({type: 'SET_APP_AGENT_ROLE_MENU_LIST', payload: resultList });    
            }else{  //하위메뉴
                const resultList = menuList.map(f => f.menuId === menuId ? Object.assign(f, {isChecked: checked, menuEmpno:''}) : f );
                dispatch({type: 'SET_APP_AGENT_ROLE_MENU_LIST', payload: resultList });
            }
      
            if(menuList.length>0) {
                const rest = menuList.map((menuList)=> menuList.menuId === menuId ? 
                    Object.assign(menuList, {isChecked: checked, orgChnlCd : searchCondition.orgChnlCd, agentNm : searchCondition.agentNm, compCd : searchCondition.compCd, hqCd : searchCondition.hqCd, agncCd : searchCondition.agncCd, rspofcCd:searchCondition.rspofcCd,  empno : searchParams.searchEmpNo, useYn:'N'}) : menuList);
      
                dispatch({type: 'SET_APP_AGENT_ROLE_MENU_LIST', payload: rest })

                const dsPensList6 = rest.find(f=> f.menuId === menuId);
                setSelectEmpnos([...new Set([...selectEmpnos, dsPensList6])])      
            }

            //const newEmpList = selectEmpnos.filter((f) =>  f.menuId !==menuId)
            //setSelectEmpnos(newEmpList);
        }      

    }      

    const columns = [
        {
          title: '사용자',
          dataIndex: 'agentNm',
          key: 'agentNm',          
          width: '50%',
          render: (value, row) => value + ' (사원번호:' +  row.empno + ')'
        },
        {
          title: '조직명',
          dataIndex: 'orgChnlCdNm',
          key: 'orgChnlCdNm',
          width: '50%',
          render: (value, row) => row.orgChnlCdNm + ' > ' + row.hqCdNm + ' > ' + row.agncCdNm
        }
    ];   

    const menuColumns = [
        {      
            title: ' ',
            dataIndex: 'rowIndex',
            key: 'rowIndex',
            width: '10%',
            checkBox:true,
            checkAll:checkAll,
            allCheckReadYn:readYn,
            allCheckAll:allMenuCheck,
            render: (value, menuList) => {
                return (
                <div className={gridClass}>
                    <input type="checkbox"
                        name={menuList.menuId}
                        disabled={readYn}
                        id={menuList.menuId}
                        //checked={menuList.isChecked === true  ? true : false}
                        checked={(menuList.menuEmpno === searchParams.searchEmpNo ? true : false) || (menuList.isChecked === true ? true : false) } 
                        onChange={(e) => singleCheck(e.target.checked, menuList.menuId)}
                    />
                    <label htmlFor={menuList.menuId}>{menuList.isChecked}</label>
                </div>
                );
            },
        },
        {
            title: '권한',
            dataIndex: 'roleCd',
            key: 'roleCd',
            selectBox:true,
            headerColSpan:2,      
            selectOption:{codeList},
            width: '20%',
            render: (value, row) => searchCondition.aplctnDvcTyCd === "01" ? 'PC' : ( searchCondition.aplctnDvcTyCd === "02" ? '테블릿' : '모바일')
        },
        {
            title: '',
            dataIndex: 'extNtwkUseYn',
            key: 'extNtwkUseYn',
            isNoHeader:true,            
            width: '10%',
            render: (value, row) => searchCondition.aplctnDvcTyCd != "01" ? '-' : (value === "Y" ? '외부' : ('내부'))
        },
        {
            title: '메뉴ID',
            dataIndex: 'menuId',
            key: 'menuId',
            width: '30%',      
          },
          {
            title: '메뉴명',
            dataIndex: 'menuNm',
            key: 'menuNm',
            width: '30%',      
          },

    ];
      
    const cdpPageChange = (value) => {

        console.log('searchCondition.chnlCd', searchCondition.orgChnlCd);
        console.log('searchCondition.hqCd', searchCondition.hqCd);
        console.log('searchCondition.agncCd', searchCondition.agncCd);
        console.log('searchCondition.agentNm', searchCondition.agentNm);
        
        //cdpList(사용자목록조회)
        dispatch(
            getAgentsTakenRole({
                orgChnlCd:searchCondition.orgChnlCd,
                hqCd:searchCondition.hqCd,
                agncCd:searchCondition.agncCd,
                agentNm:searchCondition.agentNm,
                targetRow:value*10+1
            })
        );    

        setSelectRow({
            rowIndex : ''
        });
        
        setInitial(false);

    }

    const handleInputEvent = (value, targetId) => {        
        
        if (targetId === 'agentNm') {
            setSearchCondition({
                ...searchCondition,
                'agentNm': value
            })
        }
    };

    const cdpRowSelect = (value) => {

        setSelectRow({
            rowIndex : value.rowIndex
        });

        //메뉴목록 조회
        dispatch(
            getAppAgentRoleMenu({
                empno:value.empno,
                aplctnTpCd: searchCondition.aplctnTpCd,
                aplctnDvcTyCd: searchCondition.aplctnDvcTyCd,
            })
        );

        //권한목록 조회
        dispatch(
            getAgentRoles({
                empno:value.empno,
                aplctnTpCd: searchCondition.aplctnTpCd,
                aplctnDvcTyCd: searchCondition.aplctnDvcTyCd,
            })
        );
        
         dispatch(
             updateSearchParamsInfo({                
                 searchEmpNo:value.empno
             })
         );        

         //변경된 메뉴목록 초기화
         setSelectEmpnos([]);
       
    }   

    const search = () => {

        setInitial(true);

        setSelectRow({
            rowIndex : ''
        });

         //cdpList(사용자목록조회)
         dispatch(
            getAgentsTakenRole({
                orgChnlCd:searchCondition.orgChnlCd,
                hqCd:searchCondition.hqCd,
                agncCd:searchCondition.agncCd,
                agentNm:searchCondition.agentNm,
                hqSvcOrgCd:searchCondition.hqSvcOrgCd,
                agncSvcOrgCd:searchCondition.agncSvcOrgCd,
                targetRow:1,
                callback:fncGetAgentsTakenRoleCallback
            })
        );

    }

    const fncGetAgentsTakenRoleCallback = (status, type, data) => {
        
        if(status === 200) {           
            
            if(data.RSLT_DATA.pagingResult.rows === 0) {
                dispatch(
                    updateSearchParamsInfo({                        
                        searchEmpNo:''
                    })
                );
            }
        }

    }

    const edit = () => {

        if(searchParams.empno === '') {
            dispatch(
                showModal({
                    visible: true,
                    type: 'info',
                    msg: '권한 수정할 사용자를 선택해주세요.',
                })
            );
        }else{
            setGridClass('check-wrap chk-style');
            setReadYn(false);
            setAgentVisible(false);
            setAgentEditVisible(true);
        }

    }

    const cancel = () => {
        
        //변경된 메뉴목록 초기화
        setSelectEmpnos([]);

        //cdpList(사용자목록조회)
        dispatch(
            getAgentsTakenRole({
                chnlCd:searchCondition.chnlCd,
				hqCd:searchCondition.hqCd,
				agncCd:searchCondition.agncCd,
				agentNm:searchCondition.agentNm
            })
        );

        setPageNum({pageIndex: 0});
        setSelectRow({rowIndex : ''});
        setReadYn(true);
        setAgentVisible(true);
        setAgentEditVisible(false);
        setInitial(true);

        dispatch(
            updateSearchParamsInfo({
                empno:'',
                searchEmpNo:''
            })
        );

        setGridClass('check-wrap chk-style disabled');

    }

    const save = () => {        

        const selectMenuList = menuList.filter(item => (item.menuEmpno === searchParams.searchEmpNo) || (item.isChecked === true));

        if(selectMenuList.length === 0) {
            dispatch(
                showModal({
                    visible: true,
                    type: 'info',
                    msg: '1개이상의 메뉴를 선택해주세요.'
                })
            );
        }else{
            if(selectEmpnos.length > 0) {
    
                dispatch(
                    showModal({
                      visible: true,
                      type: 'confirm',
                      msg: '저장하시겠습니까?',
                      onOk: {
                        label: '확인',
                        handle: () => {                        
                            dispatch(saveAppAgentRoleMenu(selectEmpnos));
                            setAgentVisible(true);
                            setAgentEditVisible(false);   
                            setReadYn(true);
                            setGridClass('check-wrap chk-style disabled');
                        },
                      },
                      onCancel: { label: '취소', handle: () => {} },
                    }),
                  );
                
            }else{
                dispatch(
                    showModal({
                        visible: true,
                        type: 'info',
                        msg: '변경내역이 없습니다.',
                    })
                );
            }            
        }
    }      

    const handleChangeSelect = (e) => {    
        
        setSearchCondition({
            ...searchCondition,
            aplctnDvcTyCd:e.target.value
        });

        dispatch(
            getAppAgentRoleMenu({
                empno: searchParams.searchEmpNo,
                aplctnTpCd: searchCondition.aplctnTpCd,
                aplctnDvcTyCd: e.target.value,
            })
        );
    }

    const agentColumns = [
        {
          title: '권한목록',
          dataIndex: 'roleNm',
          key: 'roleNm',          
          width: '50%'
        },
        {
          title: '설명',
          dataIndex: 'roleId',
          key: 'roleId',
          width: '50%',      
        }
    ];   

    const allAgentCheck = (checked) => {
    }

    const singleAgnetCheck = (checked, roleId) => {
        
        if(checked === true) {
            const index = agentList.findIndex(s => s.roleId === roleId);
            const checkMenuId = Object.assign(agentList[index], {isChecked:checked});
            
            agentList[index] = checkMenuId;
      
            if(agentList.length>0) {
                const rest = agentList.map((agentList)=> agentList.roleId === roleId ? Object.assign(agentList, {isChecked: checked, useYn:'N'}) : agentList);
                dispatch({type: 'SET_AGENT_ROLES', payload: rest })            
            }
            
        } else {
            
            const roleAgent = agentList.map(f=> f.roleId === roleId ? Object.assign(f, {isChecked: checked, useYn:'Y'}) : f );
            dispatch({type: 'SET_AGENT_ROLES', payload: roleAgent });


        }

    }

    const agentEditColumns = [
        {      
            title: '권한',
            dataIndex: 'fstRegDdtm',
            key: 'fstRegDdtm',
            width: '10%',
            checkBox:true,
            checkAll:checkAll,
            allCheckReadYn:readYn,
            allCheckAll:allAgentCheck,
            render: (value, agentList) => {
                return (
                <div className="check-wrap chk-style">
                    <input type="checkbox" 
                        name={agentList.roleId}                        
                        id={agentList.roleId}
                        //checked={agentList.isChecked === true ? false : true}
                        onChange={(e) => singleAgnetCheck(e.target.checked, agentList.roleId)}
                    />
                    <label htmlFor={agentList.roleId}></label>
                </div>
                );
            },
        },
        {
            title: '권한목록',
            dataIndex: 'roleNm',
            key: 'roleNm',          
            width: '50%'
        },
        {
            title: '설명',
            dataIndex: 'roleId',
            key: 'roleId',
            width: '50%',      
        }
    ];

    const agentDel = () => {    

        const dsPensList6 = agentList.find(f=> f.useYn === 'N');

        if(dsPensList6 === undefined) {

            dispatch(
                showModal({
                    visible: true,
                    type: 'info',
                    msg: '삭제할 권한을 선택해주세요.',
                })
            );

        }else{

            dispatch(
                showModal({
                  visible: true,
                  type: 'confirm',
                  msg: '권한을 삭제하시겠습니까?',
                  onOk: {
                    label: '확인',
                    handle: () => {                        
                        
                        if(searchCondition.agentNo === '') {
                
                            setSearchCondition({
                                ...searchCondition,
                                'agentNo': agentTakenList[0].empno
                            })
                        }       
                
                        dispatch(
                            saveRoleAgents(agentList)
                        );                
                       
                        setSelectRow({rowIndex : ''});
                        setReadYn(true);
                        setAgentVisible(true);
                        setAgentEditVisible(false);

                    },
                  },
                  onCancel: { label: '취소', handle: () => {} },
                }),
              );
        }
    }

    const handleChangeChnlCdSelect = (e) => {

        if(e.target.id === 'selectChnlId') {
            setSearchCondition({
                ...searchCondition,
                orgChnlCd:e.target.value,
                hqCd:'',
                agncCd:''
            });

            dispatch(
                getHqListByChannel({              
                  'chnlCd': e.target.value
              }),
            );  

            dispatch(getHqAgencyClear());
            
        }else if(e.target.id === 'selectHqId') {
            setSearchCondition({
                ...searchCondition,                        
                hqCd:e.target.value,
                hqSvcOrgCd:e.target.value
            });  

            dispatch(
                getAgencyListByHq({              
                  'chnlCd': searchCondition.orgChnlCd,
                  'hqCd': e.target.value,
                  'hqSvcOrgCd': e.target.value,
                  'agncCd':''
              }),
            );
        }else if(e.target.id === 'selectAgncId') {
            setSearchCondition({
                ...searchCondition,
                agncCd:e.target.value,
                agncSvcOrgCd:e.target.value
            });
        }

    }

      //엑셀다운로드
      const excelDown = () => {
          
        if(searchParams.searchEmpNo !== '') {

            const today = getToday('yyyyMMddHHmm');

            dispatch(
                roleAgentExcelDownload(
                    {   
                        excelFileName : '사용자별권한관리_'+today+'.xlsx',
                        chnlCd : searchCondition.orgChnlCd,
                        hqSvcOrgCd : searchCondition.hqCd,
                        agncSvcOrgCd : searchCondition.agncCd,
                        aplctnDvcTyCd: searchCondition.aplctnDvcTyCd,
                        agentNm : searchCondition.agentNm,
                        empno: searchParams.searchEmpNo 
                    }
                )
            )

        }else{

            dispatch(
                showModal({
                    visible: true,
                    type: 'info',
                    msg: '다운로드할 데이터가 없습니다.',
                })
            );

        }       
        
    }

    const onPressEnter = () => {
        search();   //검색버튼 클릭
    }

    return (       
        <React.Fragment>
            <Layout>
                <div className="content manage-content">
                <div className="con-wrap">
                    <div className="app-wrap">
                        <div className="app-box">
                            <div className="tit-area">
                                <h2 className="tit-con">사용자별 권한 관리</h2>
                            </div>                            
                            <div className="search-box">
                                <div className="data-group-left">
                                    <div className="data-area">
                                        <span className="data-tit">채널</span>
                                        <div className="sel-group">                                            
                                            <select id='selectChnlId' onChange={handleChangeChnlCdSelect} value={searchCondition.orgChnlCd}>
                                                <option value="">전체</option>
                                                {codeList.map(option => (
                                                    <option value={option.cdVal} key={option.cdVal}>{option.cmnCdNm}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="data-group-left">
                                    <div className="data-area">
                                        <span className="data-tit">본부</span>
                                        <div className="sel-group">
                                            <select id='selectHqId' onChange={handleChangeChnlCdSelect} value={searchCondition.hqCd}>
                                                <option value="">전체</option>
                                                {hqList.map(option => (
                                                    <option value={option.hqCd} key={option.hqCd}>{option.hqNm}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="data-group-left">
                                    <div className="data-area">
                                        <span className="data-tit">지점</span>
                                        <div className="sel-group">
                                            <select id='selectAgncId' onChange={handleChangeChnlCdSelect} value={searchCondition.agncCd}>
                                                <option value="">전체</option>
                                                {agencyList.map(option => (                                                    
                                                    <option value={option.agncCd} key={option.agncCd}>{option.agncNm}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="data-group-left">
                                    <div className="data-area">
                                        <span className="data-tit">성명</span>
                                        <SatInput
                                            value={searchCondition.agentNm}
                                            type="text"
                                            id="searchNamePop2"
                                            border
                                            customInputClass="line1"
                                            onChange={value => handleInputEvent(value, 'agentNm')}
                                            onPressEnter={() => onPressEnter()}
                                        />
                                    </div>
                                </div>
                                <button className="btn-search" onClick={() => search()}>검색</button>
                            </div>
                            
                            <div className="col-tbl-wrap">
                                <div className="table-wrap-reg">
                                    <div className="tit-mini">전체 {agentTotalCount}건</div>
                                    <div className="table-wrap">
                                        <SatDataGrid
                                            columns={columns}
                                            dataSource={agentTakenList}
                                            onRowSelection={cdpRowSelect}
                                            noDataRender={'검색결과가 없습니다.'}
                                            customStyleClass={'depth1'}
                                            setRowStyle={(data) => {
                                                if(selectRow.rowIndex === data.rowIndex){
                                                    return 'active'
                                                }
                                            }}
                                        />
                                    </div>
                                    <SatPagination initial={initial} totalCount={agentTotalCount} onChange={cdpPageChange} />
                                </div>
                                
                                <div className="table-wrap-reg">
                                    <div className="no-round-box">
                                        <div className="tit-area">
                                            <h3>사용자정보</h3>
                                        </div>                                        
                                        <div className="table-wrap table-wrap-scroll">
                                            <SatDataGridNew
                                                columns={menuColumns}
                                                dataSource={menuList}
                                                noDataRender={'검색결과가 없습니다.'}
                                                //onRowSelection={rowSelect}
                                                customStyleClass={'depth1'}
                                                handleChangeSelect={handleChangeSelect}
                                                selectVal={searchCondition.aplctnDvcTyCd}                                                
                                            /> 
                                        </div>                                        
                                        {!readYn ?(
                                        <div className="search-box none">
                                            <div className="data-group">
                                                <button className="btn-m del" onClick={() => agentDel()}>삭제</button>
                                            </div>
									    </div>):('')}  
                                        <div className="tbl-page-wrap">
                                            <AgentListRead visible={agentVisible} agentColumns={agentColumns} agentList={agentList} />
                                            <AgentListEdit visible={agentEditVisible} agentColumns={agentEditColumns} agentList={agentList} />
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            {readYn ?(<div className="btn-area-jb">
                                <div className="btn-area-l">
                                    <button className="memo-reg" onClick={() => excelDown()}>
                                        <span className="ico ico-exl-down"></span>
                                        엑셀 다운로드
                                    </button>
                                </div>
                                <ul className="file-list">
                                    <li>
                                        <button className="btn-m modify" onClick={() => edit()}>수정</button>
                                    </li>
                                </ul>
                            </div>):(<div className="btn-area-jb">
							<ul className="file-list">
								<li>
									<button className="btn-m cancel" onClick={() => cancel()}>취소</button>
								</li>
								<li>
									<button className="btn-m save" onClick={() => save()}>저장</button>
								</li>
							</ul>
						</div>)}                            
                        </div>
                    </div>
                </div>
            </div>
            </Layout>
        </React.Fragment>
    );
};

export default memo(AgentRole);